import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import Store from "@/domains/Stores/Store";
import RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import RpcDataSort from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы со складами
 */
class StoresDAO {

	static async getList(
		filters?: {
			partnerId?:        number;
			hasTransportZone?: boolean;
			transportZoneId?:  number;
			pattern?:          string;
		},
		pagination?: RpcDataPagination,
		sort?:       RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('stores.getList', filters, pagination, sort);
	}

	static async get(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('stores.get', { id });
	}

	static async add(store: Store, partnerId: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('stores.add', {
			store,
			partnerId
		});
	}

	static async update(store: Store): Promise<RpcResponse> {
		return await RpcService.makeRequest('stores.update', { store });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('stores.delete', { id });
	}
}

export default StoresDAO;
